export default __webpack_public_path__ + "locales/fi/DeleteSelfProfileDialog.json?hash=5326533e4216ca0b94ab2e856fd6920f";